module.exports = __webpack_public_path__ + "img/p18.703d5ae3.png";